import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

import { type useDirectContactFormSubmit } from '../../../direct-contact'

export const DirectContactFormSubmitNotification: FC<{
  submitStatus: ReturnType<typeof useDirectContactFormSubmit>['submitStatus']
}> = ({ submitStatus }) => {
  if (submitStatus !== 'success') {
    return null
  }

  return (
    <Notification
      className="mb-4"
      data-qa-id="contact-form-submit-success-notification"
      severity="success"
    >
      <FormattedMessage id="direct.contact.form.submit.success.notification.text" />
    </Notification>
  )
}
